__turbopack_context__.v({
  "className": "poppins_20a52ad1-module__jkc9Iq__className",
});
